import { getArrowPuzzleForCategory } from './arrowPuzzleGenerator';

/** Categories from theme that have a puzzle and appear in default_cat order. */
export function categoriesWithPuzzles(themeData) {
  const order = Array.isArray(themeData?.default_cat)
    ? themeData.default_cat.map((c) => String(c).toUpperCase())
    : [];
  return order.filter((cat) => {
    const p = getArrowPuzzleForCategory(themeData, cat);
    return p?.paths?.length > 0;
  });
}

/** @param {Record<string, { score?: number, timeSec?: number }>} byCategory */
export function isArrowCategoryPlayedFromMap(categoryUpper, byCategory) {
  const cat = String(categoryUpper || '').toUpperCase();
  return byCategory != null && byCategory[cat] != null;
}

/** Every puzzle category has a saved result in `byCategory`. */
export function allArrowCategoriesCompleteFromMap(themeData, byCategory) {
  const need = categoriesWithPuzzles(themeData);
  if (!need.length) return false;
  return need.every((c) => byCategory != null && byCategory[c] != null);
}
